import { Typography } from "antd";
import { useGeocoding } from "./useGeocoding";

const { Text } = Typography;

export const DireccionGeocoded = ({ latLng, onDireccionChange, onLoadingChange }) => {
  const { direccion, isLoading } = useGeocoding(latLng, { onDireccionChange, onLoadingChange });

  return (
    <div className="crear-servicios-v2__direccion-info">
      <div style={{ marginBottom: 8 }}>
        <Text strong>Dirección: </Text>
        <div style={{ marginTop: 4 }}>
          <Text>{isLoading ? "Cargando..." : direccion.direccionCompleta || "Seleccione una ubicación"}</Text>
        </div>
      </div>
      <div style={{ fontSize: 12 }}>
        <Text strong>Estado: </Text>
        <Text>{direccion.estado || "N/A"}</Text>
        <Text strong style={{ marginLeft: 12 }}>Municipio: </Text>
        <Text>{direccion.municipio || "N/A"}</Text>
        {direccion.cp && (
          <>
            <Text strong style={{ marginLeft: 12 }}>CP: </Text>
            <Text>{direccion.cp}</Text>
          </>
        )}
      </div>
      <div style={{ fontSize: 12, marginTop: 4 }}>
        <Text type="secondary" strong>Coordenadas: </Text>
        <Text type="secondary">{latLng.lat.toFixed(6)}, {latLng.lng.toFixed(6)}</Text>
      </div>
    </div>
  );
};
